"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ERC165Upgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _ERC165Upgradeable__factory.ERC165Upgradeable__factory;
  }
});
var _ERC165Upgradeable__factory = require("./ERC165Upgradeable__factory");